// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6069fc63","498":"65c2956d","513":"642089ca","787":"2539bbb3"}[chunkId] + ".chunk.js";
};